interface AssetTableHeadersProps {
  className?: string;
}

export function AssetTableHeaders({ className = '' }: AssetTableHeadersProps) {
  return (
    <div
      className={`bg-muted/50 rounded-lg pl-4 pr-12 py-3 text-muted-foreground ${className}`}
    >
      <div className="grid grid-cols-4 gap-4 text-xs font-medium">
        <div>Asset</div>
        <div>Blockchain Network</div>
        <div className=" justify-self-end">Amount</div>
        <div className=" justify-self-end">USD Value</div>
      </div>
    </div>
  );
}
